var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "div",
        { attrs: { id: "app" } },
        [
          _vm.$store.state.template != 4 &&
          _vm.$store.state.tenant_idBind != "3462" &&
          _vm.$store.state.tenant_idBind != "1313" &&
          _vm.$store.state.tenant_idBind != "3147" &&
          _vm.$store.state.tenant_idBind != "989"
            ? _c("Header", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.topBotShow,
                    expression: "topBotShow",
                  },
                ],
              })
            : _vm._e(),
          _vm.$store.state.tenant_idBind == "1313" ||
          _vm.$store.state.tenant_idBind == "3462" ||
          _vm.$store.state.tenant_idBind == "3147" ||
          _vm.$store.state.tenant_idBind == "989"
            ? _c("HeaderOne", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.topBotShow,
                    expression: "topBotShow",
                  },
                ],
              })
            : _vm._e(),
          _c(
            "keep-alive",
            [
              _vm.$route.meta.keepAlive
                ? _c("router-view", {
                    staticClass: "main",
                    style: { paddingTop: _vm.paddingTop() + "!important" },
                  })
                : _vm._e(),
            ],
            1
          ),
          !_vm.$route.meta.keepAlive && _vm.isRouterAlive
            ? _c("router-view", {
                staticClass: "main",
                style: { paddingTop: _vm.paddingTop() + "!important" },
              })
            : _vm._e(),
          _vm.$store.state.template == 1 && _vm.topBotShow
            ? _c("Footer")
            : _vm._e(),
          _vm.$store.state.template == 2 &&
          _vm.topBotShow &&
          _vm.$store.state.tenant_idBind != "3462"
            ? _c("FooterTwo")
            : _vm._e(),
          _vm.$store.state.template == 3 &&
          _vm.topBotShow &&
          _vm.$store.state.hostname != _vm.$store.state.demonstrationHostname &&
          _vm.$store.state.tenant_idBind != "3462"
            ? _c("FooterTwo")
            : _vm._e(),
          _vm.$store.state.template == 3 &&
          _vm.topBotShow &&
          _vm.$store.state.hostname == _vm.$store.state.demonstrationHostname
            ? _c("FooterThr")
            : _vm._e(),
          _vm.$store.state.tenant_idBind == "3462" &&
          _vm.topBotShow &&
          _vm.isShowFooter
            ? _c("FooterFour", {
                staticStyle: { position: "relative", top: "-110px" },
              })
            : _vm._e(),
          _vm.isChrome
            ? _c("div", { staticClass: "mask" }, [
                _vm._v(
                  " 本网站部分功能在safari浏览器无法使用，建议更换谷歌浏览器、360浏览器、QQ浏览器 "
                ),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }